import Vue from 'vue'
import './plugins/vuetify'
import './plugins/axios'
import App from './App.vue'
import store from './store'
import router from './router'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false

Vue.filter('toDateStr', function (date) {
  if (!date) return ''
  date = date.split('-')
  return new Date(parseInt(date[0]), parseInt(date[1]), parseInt(date[2])).toDateString().substr(4)
})

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
